import React from 'react';
import { ScreenReaderOnly } from '../../../../text/screen-reader-only';
import { SortMode } from '../../data-table.types';
import { DataTableSortIcon } from '../data-table-sort-icon/data-table-sort-icon';
import * as S from './data-table-head.styles';
export const DataTableHead = ({ columns }) => {
    const handleSort = React.useCallback((config) => {
        if (!config) {
            return;
        }
        if (config.activeMode === SortMode.OFF) {
            config.onChange(SortMode.ASC);
        }
        if (config.activeMode === SortMode.ASC) {
            config.onChange(SortMode.DESC);
        }
        if (config.activeMode === SortMode.DESC) {
            config.onChange(SortMode.ASC);
        }
    }, []);
    if (!(columns === null || columns === void 0 ? void 0 : columns.length)) {
        return null;
    }
    return (React.createElement(S.DataTableHeader, null,
        React.createElement("tr", null, columns.map((column) => {
            var _a;
            return (React.createElement(S.DataTableHeading, { isSortable: !!column.sortConfig, key: column.key, align: column.align, width: column.width, "data-testid": `datatable-${column.key}`, onClick: () => handleSort(column.sortConfig) },
                React.createElement(S.DataTableHeadingTitle, null,
                    column.hideHeading ? React.createElement(ScreenReaderOnly, null, column.heading) : column.heading,
                    ' ',
                    React.createElement(DataTableSortIcon, { sortMode: ((_a = column === null || column === void 0 ? void 0 : column.sortConfig) === null || _a === void 0 ? void 0 : _a.activeMode) || SortMode.OFF }))));
        }))));
};
//# sourceMappingURL=data-table-head.js.map